import { Button } from '@snsw/react-component-library';
import React from 'react';
import PropTypes from 'prop-types';
import { IconDownload } from '@snsw/react-component-library/build/Icons/system';
import styles from './DownloadButton.module.scss';

export const DownloadButton = (props) => {
  return (
    <>
      <a href={props.href} target="_blank" rel="noreferrer">
        <Button variant="secondary">
          <IconDownload color="secondaryBlue" className={styles.downloadIcon} />
          {props.label}
        </Button>
      </a>
    </>
  );
};

DownloadButton.propTypes = {
  label: PropTypes.string,
  href: PropTypes.string,
};
